import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

// Toast notification service
// eslint-disable-next-line react-refresh/only-export-components
export const notify = {
  success: (message: string) => toast.success(message),
  error: (message: string) => toast.error(message),
  loading: (message: string) => toast.loading(message),
  custom: (message: string) => toast(message),
  promise: <T,>(
    promise: Promise<T>,
    msgs: {
      loading: string;
      success: string;
      error: string;
    }
  ) => toast.promise(promise, msgs),
  dismiss: (toastId?: string) => toast.dismiss(toastId),
  remove: (toastId?: string) => toast.remove(toastId),
};

// Toast container component
export const ToastContainer: React.FC = () => (
  <Toaster
    position="top-right"
    reverseOrder={false}
    gutter={8}
    containerClassName=""
    containerStyle={{}}
    toastOptions={{
      // Define default options
      className: '',
      duration: 4000,
      style: {
        background: '#363636',
        color: '#fff',
      },
      // Default options for specific types
      success: {
        duration: 3000,
        style: {
          background: '#4caf50',
          color: '#fff',
          border: '1px solid #45a049',
        },
        iconTheme: {
          primary: '#fff',
          secondary: '#4caf50',
        },
      },
      error: {
        duration: 5000,
        style: {
          background: '#f44336',
          color: '#fff',
          border: '1px solid #d32f2f',
        },
        iconTheme: {
          primary: '#fff',
          secondary: '#f44336',
        },
      },
      loading: {
        duration: Infinity,
      },
    }}
  />
);
